import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { App } from "@/App";
import { AuthProvider } from "@/auth/AuthContext";
import { BrandingLoader } from "@/branding/BrandingLoader";
import { ActiveAccountProvider } from "@/components/ActiveAccount";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { ThemeProvider } from "@/components/Theme";
import { WebSocketProvider } from "@/ws/WebSocketProvider";
import "@/styles.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (error instanceof Error && /\b(401|403)\b/.test(error.message)) return false;
        return failureCount < 2;
      },
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <BrandingLoader>
              <AuthProvider>
                <ActiveAccountProvider>
                  <WebSocketProvider>
                    <App />
                  </WebSocketProvider>
                </ActiveAccountProvider>
              </AuthProvider>
            </BrandingLoader>
          </BrowserRouter>
        </QueryClientProvider>
      </ThemeProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
